/* saj-fix7.js — mobile add-to-cart pass (Aug 2026).

   The product page's sticky Add to Cart bar shares the bottom strip of the
   screen with the mobile bottom nav. saj-fix7.css raises the bar above the nav;
   this mirrors the bar's own `.show` class onto <html> so that CSS can slide
   the nav away for as long as the bar is up. The `.show` toggle itself lives in
   sections/saj-product.liquid, so watch the class rather than duplicating its
   scroll threshold here. */
(function () {
  if (window.__sajFix7) return;
  window.__sajFix7 = true;

  function boot() {
    var bar = document.querySelector('[data-saj-satc]');
    if (!bar) return;
    var root = document.documentElement;
    function sync() {
      root.classList.toggle('saj-satc-up', bar.classList.contains('show'));
    }
    sync();
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['class'] });
    } else {
      window.addEventListener('scroll', sync, { passive: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
